import { useMutation } from "@tanstack/react-query";
import {
  generateAssetEventLog,
  generateChannelEventLog,
  generateFeedbackEventLog,
} from "../apis/event-log";
import { QUERY_KEYS } from "../constants";
import {
  EActionType,
  TAssetEventLogPayload,
  TChannelEventLogPayload,
  TFeedbackEventLogPayload,
} from "../models/event-logs";
import useLocalStorage from "./useLocalStorage";

const useEventLog = () => {
  const { sessionId, configures } = useLocalStorage();
  const { mutateAsync: logAsset, isPending: isLoggingAsset } = useMutation({
    mutationKey: [QUERY_KEYS.EVENT_LOG.ASSETS],
    mutationFn: async (payload: TAssetEventLogPayload) => {
      return await generateAssetEventLog(payload);
    },
  });

  const { mutateAsync: logChannel, isPending: isLoggingChannel } = useMutation({
    mutationKey: [QUERY_KEYS.EVENT_LOG.CHANNEL],
    mutationFn: async (payload: TChannelEventLogPayload) =>
      await generateChannelEventLog(payload),
  });

  const { mutateAsync: logFeedback, isPending: isLoggingFeedback } =
    useMutation({
      mutationKey: [QUERY_KEYS.EVENT_LOG.CHANNEL],
      mutationFn: async (payload: TFeedbackEventLogPayload) =>
        await generateFeedbackEventLog(payload),
    });

  const gerenateEventLogPayload = ({
    actionType,
    channelPath,
    src,
    videoTitle,
  }: {
    actionType: EActionType;
    channelPath: string;
    src: string;
    videoTitle: string;
  }) => {
    return {
      sessionId: sessionId,
      kisokId: configures?.id || 0,
      communityId: configures?.communityConfiguration.communityId || 0,
      communityName: configures?.communityConfiguration.community.name || "n/a",
      communityConfigurationId: configures?.communityConfigurationId || 0,
      communityConfigurationName:
        configures?.communityConfiguration.name || "n/a",
      hostName: configures?.hostName || "LOH-K-00000000",
      channelPath,
      assetPath: src,
      action: actionType,
      videoTitle,
    };
  };

  return {
    isLoggingChannel,
    isLoggingAsset,
    isLoggingFeedback,
    logChannel,
    logAsset,
    logFeedback,
    gerenateEventLogPayload,
  };
};

export default useEventLog;
